import { appEntry } from '@/mocks/home';

export default function App() {
  return (
    <section id="app" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="bg-gradient-to-br from-primary-100/70 via-accent-50/50 to-background-50 rounded-xl p-6 md:p-10 border border-primary-200/50">
          <div className="flex flex-col lg:flex-row items-center gap-6 md:gap-8">
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                {appEntry.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4 max-w-lg">
                {appEntry.desc}
              </p>
              <div className="flex flex-wrap gap-2">
                {appEntry.features.map((feat, idx) => (
                  <span
                    key={idx}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-full bg-background-50 text-foreground-700 border border-background-300/60 whitespace-nowrap"
                  >
                    <i className="ri-check-line text-accent-500"></i>
                    {feat}
                  </span>
                ))}
              </div>
            </div>
            <div className="shrink-0">
              <div className="w-40 md:w-48 aspect-[3/4] bg-background-50 rounded-xl border-2 border-background-300/60 flex flex-col items-center justify-center gap-3 p-4">
                <div className="w-12 h-12 rounded-2xl bg-primary-500 flex items-center justify-center">
                  <i className="ri-book-read-line text-background-50 text-xl"></i>
                </div>
                <span className="text-sm font-heading text-primary-500">丫丫漫画</span>
                <span className="text-xs text-foreground-500">添加到主屏幕</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}